import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartProducts: [],
};

const cartSlice = createSlice({
  name: "cartSlice",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      state.cartProducts = [...state.cartProducts, action.payload];
    },
    removeFromCart: (state, action) => {
      const cartProducts = state.cartProducts;
      state.cartProducts = cartProducts.filter(
        (d) => d?.stockId !== action.payload
      );
    },
    updateProduct: (state, action) => {
      const { _id: productId } = action.payload;
      
      const updatedProducts = state.cartProducts.map((d) => {
        if (d?.stockId === productId) {
          return { ...d, ...action.payload };
        }
        return d;
      });

      state.cartProducts = updatedProducts;
    },
    updateCartQuantity: (state, action) => {
      const { productId, stockId, quantity } = action.payload;
      const idToMatch = stockId || productId; // Support both stockId and productId for backward compatibility
      const updatedProducts = state.cartProducts.map((product) => {
        if (product.stockId === idToMatch) {
          return { ...product, quantity };
        }
        return product;
      });

      state.cartProducts = updatedProducts;
    },
    resetCart: (state) => {
      state.cartProducts = [];
    }
  },
});

export const {
  addToCart,
  updateCartQuantity,
  updateProduct,
  removeFromCart,
  resetCart
} = cartSlice.actions;
export default cartSlice.reducer;
